import {
  CheckResourceStatus,
  SecurityInsightsCheckResource,
} from '@cast/types';

import {
  SearchBoxCriterion,
  makeSearchBoxCriteria,
} from '@cast/shared-search-ui';

export const resourceSearchBoxCriteria: SearchBoxCriterion<SecurityInsightsCheckResource>[] =
  [
    ...makeSearchBoxCriteria<SecurityInsightsCheckResource>(
      {
        title: 'Resource name:',
        key: 'name',
      },
      {
        title: 'Kind:',
        key: 'kind',
        allowMultiple: true,
        options: [
          'Deployment',
          'DaemonSet',
          'StatefulSet',
          'CronJob',
          'Job',
          'Pod',
          'Node',
        ],
      }
    ),
    { key: 'namespace' },
    { key: 'clusterId' },
    { key: 'labels' },
    { key: 'type', initialValue: CheckResourceStatus.affected },
  ];
